import { render } from "./SettingsLink.vue?vue&type=template&id=05abde26&scoped=true"
import script from "./SettingsLink.vue?vue&type=script&lang=js"
export * from "./SettingsLink.vue?vue&type=script&lang=js"

import "./SettingsLink.vue?vue&type=style&index=0&id=05abde26&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-05abde26"

export default script